import { render, staticRenderFns } from "./Coding.vue?vue&type=template&id=265daac0"
import script from "./Coding.vue?vue&type=script&lang=js"
export * from "./Coding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports